import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, Hash, Building2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface OrderInfoHeaderProps {
  supplierName: string;
  orderId: string;
  deliveryDate: string;
  status: string;
  className?: string;
}

export const OrderInfoHeader = ({ 
  supplierName, 
  orderId, 
  deliveryDate, 
  status,
  className 
}: OrderInfoHeaderProps) => {
  const getStatusVariant = (status: string) => {
    switch (status.toLowerCase()) {
      case 'completed':
        return 'default';
      case 'processing':
        return 'secondary';
      case 'pending':
        return 'outline';
      default:
        return 'outline';
    }
  };

  return (
    <Card className={cn("border-muted bg-card/50", className)}>
      <CardContent className="p-4">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {/* Supplier Info */}
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Building2 className="w-4 h-4 text-primary" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground uppercase tracking-wide">Supplier</p>
              <p className="font-semibold text-foreground">{supplierName}</p>
            </div>
          </div>

          {/* Order ID */}
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary/10 rounded-lg">
              <Hash className="w-4 h-4 text-primary" />
            </div>
            <div>
              <p className="text-xs text-muted-foreground uppercase tracking-wide">Order ID</p>
              <p className="font-mono text-sm font-medium text-foreground">{orderId}</p>
            </div>
          </div>

          {/* Delivery Date & Status */}
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-primary/10 rounded-lg">
                <Calendar className="w-4 h-4 text-primary" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground uppercase tracking-wide">Delivery</p>
                <p className="text-sm font-medium text-foreground">{deliveryDate}</p>
              </div>
            </div>
            
            <Badge variant={getStatusVariant(status)} className="ml-auto">
              {status}
            </Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};